import { createContext, PropsWithChildren, useCallback, useContext, useMemo } from "react";
import { useStatusModal } from "../../hooks/useStatusModal";

export type NotifyModalContextType = {
  modalNotify: (status: "info" | "success" | "error", title: string, description?: string, cta?: string) => void;
};

export const NotifyModalContext = createContext({} as NotifyModalContextType);

export const useNotifyModalContext = () => useContext(NotifyModalContext);

export function NotifyModalContextProvider({ children }: PropsWithChildren) {
  const { setBody, Modal } = useStatusModal("Notify");

  const modalNotify = useCallback(
    (status: "info" | "success" | "error", title: string, description?: string, cta?: string) => {
      setBody({
        data: {
          title,
          description,
          cta,
        },
        status,
        callback: () => setBody(null),
        ...(!cta && { dismissAfter: 3500, dismissCallback: () => setBody(null) }),
      });
    },
    [setBody]
  );

  const contextValue = useMemo(
    () => ({
      modalNotify,
    }),
    [modalNotify]
  );

  return (
    <NotifyModalContext.Provider value={contextValue}>
      {children}
      {Modal}
    </NotifyModalContext.Provider>
  );
}
